
define('ldsh!modules/form_editor/templates/preview_custom_password', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if(labelVisible) { ;
__p += '\n  <label class="control-label col-sm-3" for="" style="display: block;">' +
((__t = ( labelText )) == null ? '' : __t) +
'</label>\n';
 } ;
__p += '\n<div class="col-sm-9 js-control">\n  <input type="password"\n         data-querymap="' +
((__t = ( variable )) == null ? '' : __t) +
'"\n         name="' +
((__t = ( nameAttr )) == null ? '' : __t) +
'"\n         placeholder="' +
((__t = ( placeholder )) == null ? '' : __t) +
'"\n         class="form-control js-password ' +
((__t = ( isRequired ? 'form-element-required': '' )) == null ? '' : __t) +
'"\n         id="' +
((__t = ( elementId )) == null ? '' : __t) +
'"\n  />\n</div>\n';
 if(confirmation) { ;
__p += '\n  ';
 if(labelVisible) { ;
__p += '\n    <label class="control-label col-sm-3" for="" style="display: block;">' +
((__t = ( confirmationLabel )) == null ? '' : __t) +
'</label>\n  ';
 } ;
__p += '\n  <div class="col-sm-9 js-control">\n    <input type="password"\n           data-querymap="' +
((__t = ( variable )) == null ? '' : __t) +
'"\n           placeholder="' +
((__t = ( confirmationPlaceholder )) == null ? '' : __t) +
'"\n           class="form-control js-password-confirmation"\n           id="' +
((__t = ( elementId )) == null ? '' : __t) +
'"\n           data-confirmation-different-message="' +
((__t = ( confirmationDifferentMessage )) == null ? '' : __t) +
'"\n    />\n  </div>\n';
 } ;
__p += '\n';

}
return __p
};});

